import { css } from '@betterment/samba-styled-system/css';
import { numberRoundDownWithDecimals } from '@betterment/shared-components';

type Props = {
  confidencePercent: number;
  isOnTrack: boolean;
};

export const CompletionConfidence = ({ confidencePercent, isOnTrack }: Props) => {
  return (
    <span>
      <span className={css({ color: isOnTrack ? 'text.success' : 'text' })}>
        {isOnTrack ? 'On track' : 'Off track'}
      </span>{' '}
      - {numberRoundDownWithDecimals(confidencePercent, 0)}% chance of reaching your goal.
      {!isOnTrack && ' Adjust your target or savings to hit your goal on time.'}
    </span>
  );
};
